import classnames from 'classnames';

import { getCursorClass } from 'Components/utils/form/form.util';

export const themes = {
  default: props => ({
    thInputWrapper: 'relative w-full',
    thInput: classnames(
      `reset-input reset-select h-full relative ${
        props.mediumText ? 'text-md' : 'text-base'
      } text-gray-darker w-full`,
      getCursorClass(props),
    ),
    thPlaceholder: '',
    thCaret: classnames(
      'absolute flex h-full items-center top-0 rtl:right-0 pointer-events-none rtl:pl-3',
      {
        'text-current': !props.isDisabled,
        'text-gray-darker': props.isDisabled,
      },
    ),
  }),
};
